import { axios } from '@Root/API'

export const getFormById = id => {
  return axios.get(`cognito-forms/${id}`)
}
